import React, { createContext, useContext } from 'react';
import { Holding, PortfolioStats, Transaction } from '../types';

export interface PortfolioContextValue {
  holdings: Holding[];
  stats: PortfolioStats;
  transactions: Transaction[];
}

const defaultStats: PortfolioStats = {
  totalValue: 0, totalCost: 0, totalPnl: 0, totalPnlPercent: 0,
  change24h: 0, change24hValue: 0, assetCount: 0,
  display: {
    totalValue: 0, totalCost: 0, totalPnl: 0, totalPnlPercent: 0,
    change24hValue: 0, fxEstimated: false,
  },
};

const PortfolioContext = createContext<PortfolioContextValue>({
  holdings: [],
  stats: defaultStats,
  transactions: [],
});

export function PortfolioProvider({
  holdings,
  stats,
  transactions,
  children,
}: PortfolioContextValue & { children: React.ReactNode }) {
  return (
    <PortfolioContext.Provider value={{ holdings, stats, transactions }}>
      {children}
    </PortfolioContext.Provider>
  );
}

export function usePortfolioContext(): PortfolioContextValue {
  return useContext(PortfolioContext);
}
